import { createContext } from 'react';
import type { RefObject } from 'react';

export interface SiteHeaderContextType {
  siteHeaderElementRef?: RefObject<HTMLElement | null>;
}

export const SiteHeaderContext = createContext<SiteHeaderContextType | undefined>(undefined);
